// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/residential-hero-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.residential-page {
  padding-top: 0px;
  min-height: calc(100vh - 80px);
}

/* Hero Section */
.residential-hero {
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
              url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover;
  height: 50vh;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  padding: 2rem;
}

.hero-content {
  max-width: 800px;
}

.hero-content h1 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  color: #D4AF37;
}

.hero-content p {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  line-height: 1.6;
}

/* Services Section */
.services-section {
  padding: 4rem 2rem;
  background-color: #000000;
  color: white;
}

.section-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
}

.section-header h2 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 2.5rem;
  color: white;
  margin-bottom: 1rem;
}

.section-header p {
  font-size: 1.1rem;
  opacity: 0.9;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  color: #333;
  display: flex;
  flex-direction: column;
}

.service-header {
  padding: 1.5rem;
  text-align: center;
}

.service-type {
  color: #526015;
  font-size: 1.2rem;
  font-weight: bold;
  display: block;
  margin-bottom: 1rem;
}

.price-block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.starting-at {
  font-size: 0.9rem;
  color: #666;
}

.price {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
}

.price::before {
  content: "\$";
  font-size: 1.5rem;
  vertical-align: super;
}

.duration-banner {
  background: #526015;
  color: white;
  padding: 0.75rem;
  text-align: center;
  font-weight: bold;
}

.duration-note {
  font-size: 0.9rem;
  opacity: 0.9;
}

.service-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.service-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.service-features {
  padding: 1.5rem;
  flex-grow: 1;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.checkmark {
  color: #526015;
  margin-right: 0.5rem;
  font-weight: bold;
}

.get-quote-button {
  width: 100%;
  padding: 1rem;
  background: #526015;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.get-quote-button:hover {
  background: #455112;
}

.book-online-container {
  text-align: center;
  margin-top: 3rem;
}

.book-online-button {
  background: #D4AF37;
  color: white;
  padding: 1rem 3rem;
  border: none;
  border-radius: 5px;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.book-online-button:hover {
  background: #c4a030;
}

@media (max-width: 768px) {
  .residential-hero {
    height: 40vh;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
    max-width: 500px;
  }
}

@media (max-width: 480px) {
  .services-section {
    padding: 2rem 1rem;
  }

  .hero-content h1 {
    font-size: 2rem;
  }

  .service-type {
    font-size: 1.1rem;
  }

  .price {
    font-size: 2rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/ResidentialPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE;kEACiE;EACjE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".residential-page {\n  padding-top: 0px;\n  min-height: calc(100vh - 80px);\n}\n\n/* Hero Section */\n.residential-hero {\n  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),\n              url('../assets/residential-hero-bg.jpg') center/cover;\n  height: 50vh;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: white;\n  padding: 2rem;\n}\n\n.hero-content {\n  max-width: 800px;\n}\n\n.hero-content h1 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  color: #D4AF37;\n}\n\n.hero-content p {\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n}\n\n/* Services Section */\n.services-section {\n  padding: 4rem 2rem;\n  background-color: #000000;\n  color: white;\n}\n\n.section-header {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto 3rem;\n}\n\n.section-header h2 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 2.5rem;\n  color: white;\n  margin-bottom: 1rem;\n}\n\n.section-header p {\n  font-size: 1.1rem;\n  opacity: 0.9;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.service-card {\n  background: white;\n  border-radius: 10px;\n  overflow: hidden;\n  color: #333;\n  display: flex;\n  flex-direction: column;\n}\n\n.service-header {\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.service-type {\n  color: #526015;\n  font-size: 1.2rem;\n  font-weight: bold;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n.price-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.starting-at {\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.price {\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.price::before {\n  content: \"$\";\n  font-size: 1.5rem;\n  vertical-align: super;\n}\n\n.duration-banner {\n  background: #526015;\n  color: white;\n  padding: 0.75rem;\n  text-align: center;\n  font-weight: bold;\n}\n\n.duration-note {\n  font-size: 0.9rem;\n  opacity: 0.9;\n}\n\n.service-image {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n}\n\n.service-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.service-features {\n  padding: 1.5rem;\n  flex-grow: 1;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.checkmark {\n  color: #526015;\n  margin-right: 0.5rem;\n  font-weight: bold;\n}\n\n.get-quote-button {\n  width: 100%;\n  padding: 1rem;\n  background: #526015;\n  color: white;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.get-quote-button:hover {\n  background: #455112;\n}\n\n.book-online-container {\n  text-align: center;\n  margin-top: 3rem;\n}\n\n.book-online-button {\n  background: #D4AF37;\n  color: white;\n  padding: 1rem 3rem;\n  border: none;\n  border-radius: 5px;\n  font-size: 1.2rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.book-online-button:hover {\n  background: #c4a030;\n}\n\n@media (max-width: 768px) {\n  .residential-hero {\n    height: 40vh;\n  }\n\n  .hero-content h1 {\n    font-size: 2.5rem;\n  }\n\n  .section-header h2 {\n    font-size: 2rem;\n  }\n\n  .services-grid {\n    grid-template-columns: 1fr;\n    max-width: 500px;\n  }\n}\n\n@media (max-width: 480px) {\n  .services-section {\n    padding: 2rem 1rem;\n  }\n\n  .hero-content h1 {\n    font-size: 2rem;\n  }\n\n  .service-type {\n    font-size: 1.1rem;\n  }\n\n  .price {\n    font-size: 2rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
